/*-----------------------------------------------------------------
- About
-----------------------------------------------------------------*/
export default {
    title: 'About us',

    team_title: 'اسمع من الفريق',

    career: {
        title  : 'نحن نوظف!',
        tab_all: 'الجميع',
        index  : '({0})',
        button : 'قدم الآن',
        empty  : 'لم يتم العثور على مهنة',
    },

    case: {
        title : 'دراسات الحالة ذات الصلة',
        button: 'عرض دراسات الحالة',
    },
};
